module.exports = __webpack_public_path__ + "img/neobet_2026_1_640x200.74b6b0ac.png";